<template>
   <div class="modal fade" id="boardFilter" aria-hidden="true" aria-labelledby="boardFilterLabel" tabindex="-1">
      <div class="modal-dialog">
         <div class="modal-content bg-light">
            <div class="modal-header">
               <h6 class="modal-title" id="boardFilterLabel"><b>Filtrar</b></h6>
               &nbsp;&nbsp;
               <userCircle v-if="sfilterUserId > 0" :circleUser="selectedUser"/>
               &nbsp;&nbsp;
               <labelRectangle v-if="sfilterLabelId > 0" :label="selectedLabel" :format="hotdog"/>
               &nbsp;&nbsp;
               <!--
               <labelRectangle v-if="sfilterCardTypeId > 0" :label="selectedCardType" :format="hotdog"/>
               -->
               <card-rectangle v-if="sfilterCardTypeId > 0" :rectangleCard="selectedCardType"/>
               <button 
                  type="button" 
                  class="btn-close btn-small" 
                  data-bs-dismiss="modal" 
                  aria-label="Close"
                  ref="filterExit"
                  >
               </button>
            </div>
            <div class="modal-body">
               <div class="accordion accordion-flush" id="accordionFlushFilter">
                  <!-- user filter -->
                  <div v-if="usersBoard.length > 0" class="accordion-item">
                     <h2 class="accordion-header" id="flush-headingUser">
                        <button ref="userAccordionButton" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseUser" aria-expanded="false" aria-controls="flush-collapseUser">
                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                              <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                           </svg>
                           &nbsp; Seleccionar un Miembro
                        </button>
                     </h2>
                     <div id="flush-collapseUser" class="accordion-collapse collapse" aria-labelledby="flush-headingUser" data-bs-parent="#accordionFlushFilter">
                        <div class="accordion-body row gap-1">
                           <div v-for="(user, index) in usersBoard" 
                                 :key="index"
                                 class="mouse-on"
                                 @click="getFilterUser(user.id, index)"
                                 >
                              <div class="row">
                                 <div class="col-1 px-0">
                                    <userCircle :circleUser="user"/>
                                 </div>
                                 <div class="col-11 text-start tc-gray"
                                       >
                                    <b>{{user.name}}</b>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- label filter -->
                  <div class="accordion-item">
                     <h2 class="accordion-header" id="flush-headingLabel">
                        <button ref="labelAccordionButton" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-tag-fill" viewBox="0 0 16 16">
                              <path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                           </svg>
                           &nbsp; Seleccionar una Etiqueta
                        </button>
                     </h2>
                     <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingLabel" data-bs-parent="#accordionFlushFilter">
                        <div class="accordion-body">
                           <div class="row gap-1">
                              <labelRectangle 
                                 v-for="(label, index) in labelsBoard" 
                                 :key="index" 
                                 :label="label"
                                 :format="format"
                                 @click="getFilterLabel(label.id, index)"
                              />
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- card type filter -->
                  <div v-if="cardTypesBoard.length > 0" class="accordion-item">
                     <h2 class="accordion-header" id="flush-headingCardType">
                        <button ref="cardTypeAccordionButton" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseCardType" aria-expanded="false" aria-controls="flush-collapseUser">
                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-card-heading" viewBox="0 0 16 16">
                              <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                              <path d="M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1z"/>
                           </svg>                           &nbsp; Seleccionar una Tarjeta
                        </button>
                     </h2>
                     <div id="flush-collapseCardType" class="accordion-collapse collapse" aria-labelledby="flush-headingCardType" data-bs-parent="#accordionFlushFilter">
                        <div class="accordion-body row gap-1">
                           <div v-for="(cardType, index) in cardTypesBoard" 
                                 :key="index"
                                 class="mouse-on"
                                 @click="getFilterCardType(cardType.id, index)"
                                 >
                              <div class="row">
                                 <div class="col-1 px-0">
                                    <card-rectangle :rectangleCard="cardType"/>
                                 </div>
                                 <div class="col-11 text-start tc-gray"
                                       >
                                    <b>{{cardType.name}}</b>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <hr class="tc-gray">

               <!-- filter button's -->
               <div>
                  <button v-if="filterOn"
                        class="btn btn-primary col-12" 
                        type="button"
                        @click="filterBoard()"
                        >
                     Filtrar
                  </button>
                  <button v-if="filterOff"
                        class="btn btn-info col-12 mt-1"
                        type="button" 
                        @click="offFilter()"
                        >
                     Dejar de Filtrar
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import WspService from "../workSpace.service";

import userCircle from '/src/components/UserCircle.vue';
import labelRectangle from '../components/LabelRectangle.vue';
import cardRectangle from "./CardRectangle.vue";

export default {
   components: {
     userCircle,
     labelRectangle,
     cardRectangle
   },
   setup() {
      const store = useStore()
      const boardId = ref(WspService.getBoardId(store))

      const filterOff = ref(false)
      const filterOn = ref(false)
      const sfilterCardTypeId = ref("")
      const sfilterUserId = ref("")
      const sfilterLabelId = ref("")
      const filterExit = ref(null)
      const userAppModuleId = ref(0)

      const cardTypeAccordionButton = ref(null)
      const labelAccordionButton = ref(null)
      const userAccordionButton = ref(null)
      const cardTypesBoard = ref([])
      const usersBoard = ref([])
      const labelsBoard = ref([])

      const selectedCardType = ref([])
      const selectedUser = ref({})
      const selectedLabel = ref({})
      const format = "filter"
      const hotdog = "resume"

      onMounted(() => {
         document.getElementById('boardFilter')
         .addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget
            userAppModuleId.value = button.getAttribute('data-user-app-module-id')
            sfilterCardTypeId.value = "0"
            sfilterUserId.value = "0"
            sfilterLabelId.value = "0"
            filterOn.value = false
            filterOff.value = false
            if (
               store.state.wspace.filterCardTypeId > 0 || 
               store.state.wspace.filterUserId > 0 || 
               store.state.wspace.filterLabelId > 0
               ) {
               filterOff.value = true
            }
            boardId.value = WspService.getBoardId(store)
            getCardTypesBoard(boardId.value)
            getUsersBoard(userAppModuleId.value)
            getLabelsBoard(boardId.value)
         })
      })

      function filterBoard() {
         nextTick(() => { 
            store.dispatch("wspace/updateFilterCardTypeId", Number(sfilterCardTypeId.value))
            store.dispatch("wspace/updateFilterUserId", Number(sfilterUserId.value))
            store.dispatch("wspace/updateFilterLabelId", Number(sfilterLabelId.value))
            filterExit.value.click() 
         })
      }

      function getCardTypesBoard(boardId) {
         WspService.getBoardCardTypes(boardId)
         .then(response => {
            cardTypesBoard.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getLabelsBoard(boardId) {
         WspService.getBoardLabels(boardId)
         .then(response => {
            labelsBoard.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getUsersBoard(userAppModuleId) {
         WspService.getAppMembers(userAppModuleId, 0, false)
         .then(response => {
            usersBoard.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getFilterCardType(id, index) {
         sfilterCardTypeId.value = String(id)
         filterOn.value = true
         selectedCardType.value = cardTypesBoard.value[index]
         nextTick(() => { cardTypeAccordionButton.value.click() })
      }

      function getFilterLabel(id, index) {
         sfilterLabelId.value = String(id)
         filterOn.value = true
         selectedLabel.value = labelsBoard.value[index]
         nextTick(() => { labelAccordionButton.value.click() })
      }

      function getFilterUser(id, index) {
         sfilterUserId.value = String(id)
         filterOn.value = true
         selectedUser.value = usersBoard.value[index]
         nextTick(() => { userAccordionButton.value.click() })
      }

      function offFilter() {
         nextTick(() => { 
            store.dispatch("wspace/updateFilterCardTypeId", 0)
            store.dispatch("wspace/updateFilterUserId", 0)
            store.dispatch("wspace/updateFilterLabelId", 0)
            filterExit.value.click() 
         })
      }

      return {
         filterOn, filterOff,
         getFilterUser, getFilterLabel, getFilterCardType,
         filterBoard,
         sfilterCardTypeId, sfilterUserId, sfilterLabelId,
         filterExit,
         offFilter,
         cardTypesBoard, cardTypeAccordionButton, selectedCardType,
         userAppModuleId, usersBoard, userAccordionButton, selectedUser,
         labelsBoard, labelAccordionButton, format, selectedLabel, hotdog
      };
   }
}
</script>

<style scoped>
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-15 {
   font-size: 15px;
}
.tc-gray {
   color: gray;
}
</style>